import { Star } from "lucide-react";

export const Stars = ({ value = 0, onChange, size = "w-4 h-4", testId = "stars" }) => (
  <div className="inline-flex items-center gap-0.5" dir="ltr" data-testid={testId}>
    {[1, 2, 3, 4, 5].map((n) => {
      const icon = <Star className={`${size} transition-colors ${n <= value ? "fill-[#F59E0B] text-[#F59E0B]" : "text-stone-300"}`} />;
      return onChange ? (
        <button key={n} type="button" onClick={() => onChange(n)} data-testid={`${testId}-${n}`} aria-label={`${n}`}
          className="p-0.5 rounded hover:scale-110 transition-transform">{icon}</button>
      ) : <span key={n}>{icon}</span>;
    })}
  </div>
);
